import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";

export const Input = ({ placeholder, password, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="relative mb-3">
      <input
        type={showPassword ? "text" : "password"}
        className=" w-full rounded-lg border border-primary py-4 px-5 font-inter text-sm font-medium text-black text-opacity-50 focus:outline-none"
        placeholder={placeholder}
        {...props}
      />
      {password &&
        (showPassword ? (
          <FiEye
            onClick={() => setShowPassword(false)}
            className="absolute top-[50%] right-2 h-5 w-5 -translate-y-1/2 cursor-pointer text-primary"
          />
        ) : (
          <FiEyeOff
            onClick={() => setShowPassword(true)}
            className="absolute top-[50%] right-2 h-5 w-5 -translate-y-1/2 cursor-pointer text-primary"
          />
        ))}
    </div>
  );
};

export const Checkbox = ({ text, ...props }) => {
  return (
    <label className={`my-4 flex items-center gap-2`}>
      <input type="checkbox" className="" {...props} />
      <span className={`mt-[1px] font-pop text-sm font-normal text-black`}>
        {text}
      </span>
    </label>
  );
};

export const Dropdown = ({ placeholder, ...props }) => {
  return (
    <div className="relative mb-3 ">
      <input
        type="text"
        className="w-full rounded-lg border border-primary py-4 px-5 font-inter text-sm font-medium text-black text-opacity-50 focus:outline-none"
        placeholder={placeholder}
        {...props}
      />
      <IoIosArrowDown className="absolute top-[50%] right-2 h-5 w-5 -translate-y-1/2 cursor-pointer text-primary" />
    </div>
  );
};
export const IconInput = ({ placeholder, Icon, ...props }) => {
  return (
    <div className="relative mb-3 overflow-hidden rounded-lg">
      <input
        type="text"
        className="w-full rounded-lg border border-primary py-4 px-14 font-inter text-sm font-medium text-black text-opacity-50 focus:outline-none"
        placeholder={placeholder}
        {...props}
      />
      <div className="absolute top-0 left-0 grid h-full w-auto place-items-center bg-primary px-3 py-2">
        <Icon className=" h-6 w-6 bg-primary text-white" />
      </div>
    </div>
  );
};
